import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useSubmitPowerWordsQuestion = () => {
  const handleSubmitPowerWordsQuestion = useCallback((payload) => {
    return new Request(`${API_BASE_URL}/api/v2/student-vocabulary-answer/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);
  return useRestMutation(handleSubmitPowerWordsQuestion);
};

export default useSubmitPowerWordsQuestion;
